export const manifest = {
  screens: {
    scr_onaik3: { name: "91311 Landing Page", route: "/91311", position: {"x":160,"y":220} },
    scr_sy9wvd: { name: "Lead Dashboard", route: "/admin", position: {"x":160,"y":2200} },
  },
  sections: {
    sec_dx6qol: { name: "Landing Page", x: 0, y: 0, width: 1520, height: 1180 },
    sec_mzeel2: { name: "Admin Dashboard", x: 0, y: 1980, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_dx6qol", children: [
      { kind: "screen", id: "scr_onaik3" },
    ] },
    { kind: "section", id: "sec_mzeel2", children: [
      { kind: "screen", id: "scr_sy9wvd" },
    ] },
  ],
}
